import { observer } from "mobx-react-lite";
import React from "react";
import LessonScheduleFormArray from "./LessonScheduleArray";

const LessonScheduleFormPage: React.FC<{ splitInfo: any; [key: string]: any }> =
  observer(
    ({
      toNextPage,
      dataType,
      path,
      viewModel,
      submitText = "Save",
      loading,
      updateFormIndex,
      splitInfo,
    }) => {
      return (
        <LessonScheduleFormArray
          splitInfo={splitInfo}
          updateFormIndex={updateFormIndex}
          dataType={dataType}
          loading={loading}
          onNextClick={toNextPage}
          submitText={submitText}
          path={path}
          viewModel={viewModel}
          value={viewModel.inputValue}
          onSubmit={viewModel.onSubmitForm}
        />
      );
    },
  );

export default LessonScheduleFormPage;
